import { Form } from "antd";
import RelationFieldChild from "./RelationFieldChild";
import { useEffect } from "react";

function RelationField({ item, value, onChange, form }) {
  return (
    <RelationFieldChild
      item={item}
      value={value}
      onChange={onChange}
      form={form}
    />
  );
}

export default RelationField;
